import { render, staticRenderFns } from "./jiuyetongji.vue?vue&type=template&id=239a2236&scoped=true"
import script from "./jiuyetongji.vue?vue&type=script&lang=js"
export * from "./jiuyetongji.vue?vue&type=script&lang=js"
import style0 from "./jiuyetongji.vue?vue&type=style&index=0&id=239a2236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a2236",
  null
  
)

export default component.exports